import { LiquidityProviders } from '@emberswap/emberswap-sdk2/dist/entities'
import { ChainId } from '@emberswap/emberswap-sdk2/dist/enums'

import { UniswapV2BaseProvider } from './UniswapV2Base'

/**
 *
 */
export class MistSwapV2Provider extends UniswapV2BaseProvider {
  /**
   * @param {ChainId}chainId
   */
  constructor(chainId: ChainId) {
    const factory = {
      [ChainId.SMARTBCH]: '0x6008247F53395E7be698249770aa1D2bfE265Ca0',
      [ChainId.SMARTBCH_TESTNET]: '0xaa094cA3FBd19dCCcE91C79d1FffA28293B05f28',
    } as const
    const initCodeHash = {
      [ChainId.SMARTBCH]: '0xacca68b46e4aa677641d8d20d81c9f4b252af83de62ff9e2fb58a9b648ee3537',
      [ChainId.SMARTBCH_TESTNET]:
        '0xacca68b46e4aa677641d8d20d81c9f4b252af83de62ff9e2fb58a9b648ee3537',
    } as const
    super(chainId, factory, initCodeHash)
  }

  /**
   * @return {LiquidityProviders}
   */
  getType(): LiquidityProviders {
    return LiquidityProviders.MistSwapV2
  }
  /**
   * @return {string}
   */
  getPoolProviderName(): string {
    return 'MistSwap'
  }
  /**
   * @return {string}
   */
  getPoolProviderURI(): string {
    return 'https://raw.githubusercontent.com/emberswap/emberswap-tokenlist/main/assets/smartbch/0x5fA664f69c2A4A3ec94FaC3cBf7049BD9CA73129/logo.png'
  }
}
